import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";

import { UserInfo } from "../../components/UserInfo/UserInfo";
import { RoleEnum } from "../../models/User/RoleEnum";
import { useGetUserSessionQuery } from "../../queries/userQuery";
import {
  institutionDetailsRoute, dashboardRoute,
  programRequestListRoute, institutionListRoute,
  codebookRouteProgramType, codebookRouteProgramName, userRoleRoute, newProgramRequestListRoute,
  notificationRoute
} from "../../routes/routes";
import styles from "./Navigation.module.scss";


export default function Navigation() {
  const { t } = useTranslation();
  const { data: userSession } = useGetUserSessionQuery();

  return (
    <>
      {userSession &&
        <Navbar className={styles.navbar} expand="sm">
          <Container>
          {
            
            <Nav>
                {userSession && userSession.roleId !== RoleEnum.None &&
                <Nav.Link as={NavLink} to={notificationRoute()}>
                  {t("navigation.notifications")}  
                </Nav.Link>
                }
                {(userSession.roleId === RoleEnum.InstitutionAdmin || userSession.roleId === RoleEnum.InstitutionDirector ) &&
                <Nav.Link as={NavLink} to={dashboardRoute()} id="navigationDashboard">
                  {t("navigation.dashboard")}
                </Nav.Link>
              }
                {(userSession.roleId === RoleEnum.ASOO || userSession.roleId === RoleEnum.ASOOAdmin 
                    || userSession.roleId === RoleEnum.MZOM || userSession.roleId === RoleEnum.MZOMAdmin || userSession.roleId === RoleEnum.Helpdesk 
                    || userSession.roleId === RoleEnum.ASOOOffice || userSession.roleId === RoleEnum.MZOMOffice) &&
                <Nav.Link as={NavLink} to={newProgramRequestListRoute()}>
                  {t("navigation.newProgramRequestList")}
                </Nav.Link> 
                }
                {(userSession.roleId === RoleEnum.InstitutionAdmin || userSession.roleId === RoleEnum.InstitutionDirector ) &&
                <Nav.Link as={NavLink} to={institutionDetailsRoute()}>
                  {t("navigation.institutionData")}
                </Nav.Link>
              }
              {(userSession.roleId === RoleEnum.MZOM || userSession.roleId === RoleEnum.MZOMAdmin 
                  || userSession.roleId === RoleEnum.ASOO || userSession.roleId === RoleEnum.ASOOAdmin || userSession.roleId === RoleEnum.Helpdesk
                  || userSession.roleId === RoleEnum.ASOOOffice || userSession.roleId === RoleEnum.MZOMOffice) &&
                <Nav.Link as={NavLink} to={programRequestListRoute()}>
                  {t("navigation.programRequestList")}
                </Nav.Link>
              }
              {(userSession.roleId === RoleEnum.MZOM || userSession.roleId === RoleEnum.MZOMAdmin 
                  || userSession.roleId === RoleEnum.ASOO || userSession.roleId === RoleEnum.ASOOAdmin || userSession.roleId === RoleEnum.Helpdesk) &&
                <Nav.Link as={NavLink} to={institutionListRoute()}>
                  {t("navigation.institutionList")}
                </Nav.Link>
              }
              {(userSession.roleId === RoleEnum.MZOM || userSession.roleId === RoleEnum.MZOMAdmin || userSession.roleId === RoleEnum.Helpdesk) &&
                <Nav.Link as={NavLink} to={codebookRouteProgramType()}>
                  {t("navigation.codebookAdministration")}
                </Nav.Link>
              }
              {(userSession && (userSession.roleId === RoleEnum.ASOO || userSession.roleId === RoleEnum.ASOOAdmin)) &&
                <Nav.Link as={NavLink} to={codebookRouteProgramName()}>
                  {t("navigation.codebookAdministration")}
                </Nav.Link>
              }                
                {(userSession && userSession.roleId !== RoleEnum.None) &&
                <Nav.Link as={NavLink} to={userRoleRoute()}>
                  {t("navigation.userRoles")}
                </Nav.Link>
              }
              </Nav>
            }
            <UserInfo></UserInfo>
          </Container>
        </Navbar>
      }

    </>
  );
}
